export default __webpack_public_path__ + "static/media/2.de7d6ce2.jpg";